var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Incidències de les teves subcategories")]),_c('AddTicket'),(this.groups_tickets)?_c('ManagerTicketsTable',{attrs:{"table_rows":this.groups_tickets,"priorities":_vm.priorities,"states":_vm.states,"other_filters":['Suprimir duplicades o descartades']}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }